export default __webpack_public_path__ + "static/media/twitter.83f1162d.svg";